// extracted by mini-css-extract-plugin
export default {"infoBlockFooter":"index_infoBlockFooter__V5REW","options-btn-wrap":"index_options-btn-wrap__OSgcJ"};